const setTheme = (theme) => {
        // 1. 设置data-theme属性
        document.documentElement.setAttribute('data-theme', theme);
        // 2. 保存到localStorage
        localStorage.setItem(`stylestate${localStorage.getItem(`userId${localStorage.getItem("userId").split('/u/')[1]}`)}`, theme);
};

const getTheme = () => {
    return localStorage.getItem(`stylestate${localStorage.getItem(`userId${localStorage.getItem("userId").split('/u/')[1]}`)}`) || 'default';
};

export { setTheme, getTheme };